import { render, staticRenderFns } from "./page-title.vue?vue&type=template&id=1cb52fcc&scoped=true&"
import script from "./page-title.vue?vue&type=script&lang=ts&"
export * from "./page-title.vue?vue&type=script&lang=ts&"
import style0 from "./page-title.vue?vue&type=style&index=0&id=1cb52fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb52fcc",
  null
  
)

export default component.exports